import React from 'react';

interface ISectionListHeader {
	title: string;
	height: number;
}

export const SectionListHeader = (props: ISectionListHeader) => {
	const { title, height } = props;

	return (
		<div className="w-full border-b font-bold border-primary-500" style={{ height }}>
			<div>{title}</div>
		</div>
	);
};
